import {
  enableProdMode,
  inject,
  provideZoneChangeDetection,
  runInInjectionContext,
} from '@angular/core';
import {
  platformBrowserDynamic,
} from '@angular/platform-browser-dynamic';
import {
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  clearAllSessionStorage,
  isCurrentSessionValid,
} from '@refx/shared-common';
import {
  FunctionalContentOverrideActionHandler,
} from '@refx/shared-services';
import {
  AppModule,
} from './app/app.module';
import {
  environment,
} from './environments/index';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [
      provideZoneChangeDetection({
        eventCoalescing: true
      })
    ]
  })
  .then((m) => {
    runInInjectionContext(m.injector, () => {
      const rulesEngineRunnerService = inject(RulesEngineRunnerService);
      rulesEngineRunnerService.registerActionHandlers(inject(FunctionalContentOverrideActionHandler));
    });
  });

// Before initializing application and session storage, clean the session storage if the current session is not valid
if (!isCurrentSessionValid()) {
  clearAllSessionStorage();
}
